import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { removeChat } from "../../util/chatBotUtils";
import { customerSupportLink, onCloseRevealRedirectionLink, handleOnCloseEvent } from "../../util/helpURLNavigation";
import { TextLink } from "@vds/buttons";
import Cookies from "js-cookie";
import { resetRedux, checkImpersonateUser } from "../../util/util";
import { changeLanguageHandler } from "../../util/userLanguageUtils";
import { REDBALL_FEATURE_TOGGLE } from "../../constants/appConstants";
import CPFallbackPage from "./CPFallbackPage";
import { useAuth0 } from "@auth0/auth0-react";
import PropTypes from "prop-types";

function FailedToAccessAccount(props) {
  const { logout } = useAuth0();
  const { t, i18n } = useTranslation("loginTranslation");
  useEffect(() => {
    removeChat(props.regionId, props.emailAddress);
  }, []);

  useEffect(() => {
    if (Cookies.get("userLanguage")) {
      i18n.changeLanguage(changeLanguageHandler(Cookies.get("userLanguage")));
    }
    resetRedux();
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    document.title = t(`${props.title}`);
  }, [props.title]);

  const handleClose = () => {
    if (REDBALL_FEATURE_TOGGLE) {
      checkImpersonateUser() ? handleOnCloseEvent(onCloseRevealRedirectionLink()) : logout({ logoutParams: { returnTo: window.location.origin } });
    } else {
      handleOnCloseEvent(onCloseRevealRedirectionLink());
    }
  };
  return (
      <CPFallbackPage
        windowSize={props.windowSize.width}
        ariaLabel="Inactive Account"
        pageTitle={t("Failed to access account")}
        pageContent={
          Cookies.get("userLanguage") === "nl-NL" ? (
            <>
              {t("Close the browser and try again. Contact the")}{" "}
              <TextLink
                id="goto-reveal-customer-support-link"
                ariaLabel="customer support link"
                style={{ color: "#0077B4", borderColor: "#0077B4" }}
                href={customerSupportLink()}
              >
                {t("customer support.")}
              </TextLink>{" "}
              {t("if the problem persists")}
            </>
          ) : (
            <>
              {t("Please close the browser and try again. If the problem persists, contact")}{" "}
              <TextLink
                ariaLabel="customer support link"
                id="goto-reveal-customer-support-link"
                style={{ color: "#0077B4", borderColor: "#0077B4" }}
                href={customerSupportLink()}
              >
                {t("customer support.")}
              </TextLink>
            </>
          )
        }
        buttonId="failed-to-access-account-close-button"
        buttonHandler={() => handleClose()}
        buttonName={t("CLOSE")}
        buttonAriaLabel="close this tab"
      />
  );
}

const mapStateToProps = (state) => {
  return {
    windowSize: state.ACCOUNT.windowSize,
    emailAddress: state.ACCOUNT.emailAddress,
    regionId: state.ACCOUNT.regionId,
    userLanguage: state.ACCOUNT.userLanguage,
  };
};
FailedToAccessAccount.propTypes = {
  regionId: PropTypes.string,
  emailAddress: PropTypes.string,
  windowSize: PropTypes.object,
  title: PropTypes.string,
};

export default connect(mapStateToProps)(FailedToAccessAccount);